import { memo, useEffect, useState } from 'react'
import { FooterColumn, FooterItem } from '../styles'
import { COMMUNITY_LINKS } from '../../../constants/community'
import { Link } from 'react-router-dom'
import { Button, styled } from '@mui/material'
import { ReactComponent as SvgChat } from './icon-chat.svg'
import { ReactComponent as SvgMessage } from './icon-message.svg'
import clsx from 'clsx'

const LinkItem = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: ${(props) => props.theme.color.text50};

  &:hover {
    cursor: pointer;
  }
`
const ChatLauncher = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-width: 40px;
  height: 0;
  background-color: rgba(160, 238, 9, 1);
  padding: 0 8px;
  border-radius: 20px;
  position: fixed;
  bottom: 34px;
  right: 16px;
  overflow: hidden;

  span {
    display: none;
    color: rgba(22, 25, 30, 1);
    font-size: 14px;
    font-weight: 600;
  }

  &:hover {
    cursor: pointer;
    background-color: rgba(199, 255, 92, 1);
    span {
      display: block;
    }
  }

  &.in {
    height: 40px;
  }
`

export const CommunityLinks = memo(() => {
  const [displayLauncher, setDisplayLauncher] = useState(false)

  useEffect(() => {
    // window.Mava.initialize()
    // window.Mava.identify({
    //   customAttributes: [{ label: 'Customer Tier', value: 'Gold' }],
    // })
  }, [])
  return (
    <FooterColumn>
      {/* <FooterItem>
        <LinkItem to={COMMUNITY_LINKS.USER_DOCS} target="_black">
          User Guide
        </LinkItem>
      </FooterItem> */}
      <FooterItem>
        <LinkItem to={COMMUNITY_LINKS.DISCORD} target="_black">
          Get support on Discord
        </LinkItem>
      </FooterItem>
      <FooterItem>
        <LinkItem to={COMMUNITY_LINKS.BUG_REPORT} target="_black">
          Bug Report
        </LinkItem>
      </FooterItem>
      <FooterItem>
        <LinkItem
          className="mava-webchat-launcher"
          as={'a'}
          to={'javascript:;'}
          onClick={() => {
            setTimeout(() => setDisplayLauncher(true), 1000)
          }}
        >
          <SvgMessage />
          Online Support
        </LinkItem>
      </FooterItem>

      <ChatLauncher
        className={clsx({ 'mava-webchat-launcher': true, in: displayLauncher })}
      >
        <SvgChat />
        <span>Support</span>
      </ChatLauncher>
    </FooterColumn>
  )
})
